<script lang="ts">
import { h } from 'vue'

// const VERTICAL_SPACING_CLASS = ''

export interface ILayoutColumn {
  width: number
  rightMargin?: number
  items: Array<string>
}

export interface ILayout {
  headerItems: Array<string>
  columns: Array<ILayoutColumn>
  footerItems: Array<string>
}
export interface ILayoutConfig {
  breakpoint: number
  layout: ILayout
}

export default {
  props: {
    layout: { type: Object },
    classPrefix: { type: String }
  },
  methods: {
    createSection(slotNames, classes: Array<string>, width, rightMargin = 0) {
      const childNodes = []
      slotNames.forEach((name) => {
        if (this.$slots[name]) {
          childNodes.push(this.$slots[name]())
        }
      })
      let sectionStyle = width ? `flex: 0 0 auto;width: ${width}%;` : ''
      sectionStyle += rightMargin ? `margin-right: ${rightMargin}%;` : ''
      return this.createElement(childNodes, classes, sectionStyle)
    },
    createElement(childNodes, classes: Array<string>, styles: Array<string>) {
      const attrs = { class: classes || [], style: styles || [] }
      return h('div', attrs, childNodes)
    },
    classesForSuffix(classSuffix): Array<string> {
      const sectionClasses = [`tt-l-grid__${classSuffix}`]
      if (this.classPrefix) {
        sectionClasses.push(`${this.classPrefix}__grid-${classSuffix}`)
      }
      return sectionClasses
    }
  },
  render() {
    const headerNodes = []
    if (this.layout.headerItems.length) {
      const classes = this.classesForSuffix('header')
      // classes[VERTICAL_SPACING_CLASS] = true
      const header = this.createSection(this.layout.headerItems, classes)
      headerNodes.push(header)
    }

    const middleRowNodes = []
    this.layout.columns.forEach((column, i) => {
      if (column.items.length) {
        const classes = this.classesForSuffix('col').concat(this.classesForSuffix(`col--${i + 1}`))
        // classes[VERTICAL_SPACING_CLASS] = true
        const columnSection =
          this.createSection(column.items, classes, column.width, column.rightMargin)
        middleRowNodes.push(columnSection)
      }
    })

    const footerNodes = []
    if (this.layout.footerItems.length) {
      const classes = this.classesForSuffix('footer')
      // classes[VERTICAL_SPACING_CLASS] = true
      const footer = this.createSection(this.layout.footerItems, classes)
      footerNodes.push(footer)
    }

    const rowClasses = this.classesForSuffix('row')

    const rows = []
    if (headerNodes) {
      rows.push(this.createElement(headerNodes, rowClasses))
    }
    if (middleRowNodes) {
      rows.push(this.createElement(middleRowNodes, rowClasses))
    }
    if (footerNodes) {
      rows.push(this.createElement(footerNodes, rowClasses))
    }
    return this.createElement(rows, ['tt-l-grid']) // VERTICAL_SPACING_CLASS
  }
}
</script>

<style lang="scss" src="./grid-layout.scss"></style>
